<script>
  import axios from "axios";
  import { link } from "svelte-spa-router";
  import Layout from "../../Layout/Layout.svelte";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import config from "../../stores/config";
  import { Wave } from "svelte-loading-spinners";
  import * as ls from "local-storage";
  import loadData from "../../utils/loadData";

  let uploading = false;

  let name;
  let address;
  let tel;
  let email;

  const handleClear = () => {
    name = null;
    address = null;
    tel = null;
    email = null;
  };

  const handleSubmit = async (e) => {
    if ($config.suppliers.find(({ label }) => $config.f.equals(label, name))) {
      alert("⚠ This Supplier already exists");
      return;
    }

    if (!name) alert("Supplier Name Missing");
    else if (!address) alert("Address missing!");
    else if (!tel) alert("Telephone missing!");
    else if (!email) alert("Email missing!");
    else {
      uploading = true;

      let data = {
        name,
        address,
        tel,
        email,
      };

      axios
        .post(`${$config.backendURL}/suppliers`, data, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          console.log(res.data);
          uploading = false;
          alert(`☑ Added Successfully`);
          loadData();
          handleClear();
        })
        .catch((err) => {
          alert("There was a problem, Refresh the page and retry");
          console.log(err);
          uploading = false;
        });
    }
  };
</script>

<svelte:head>
  <title>Add a Supplier — Supreme Upholstery System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title="Add a new Supplier"
    description="Fill out the form below to enter the supplier details. All fields are REQUIRED."
  />

  <div class="flex justify-end mb-6">
    <a class="btn btn-primary-outline" use:link href="/suppliers">
      <i class="fas fa-arrow-left mr-3" />
      Return to Suppliers
    </a>
  </div>

  <form
    on:submit|preventDefault={handleSubmit}
    class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
  >
    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Supplier Name :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={name}
          placeholder="Supplier Name"
          required
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Address :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={address}
          placeholder="Address"
          required
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Telephone :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={tel}
          placeholder="Telephone"
          required
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Email :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={email}
          placeholder="Email"
          required
        />
      </div>
    </div>

    {#if uploading}
      <div class="grid grid-cols-1 gap-8">
        <div class="flex items-center justify-center btn btn-primary-outline">
          <Wave size="25" color="rgb(244,162,97)" unit="px" />
          <span class="ml-4">Please wait...</span>
        </div>
      </div>
    {:else}
      <!-- else content here -->
      <div class="grid grid-cols-2 gap-8">
        <button class="btn btn-primary-outline" on:click={handleClear}>
          <i class="fas fa-times-circle mr-3" />
          Clear Form
        </button>
        <button class="btn btn-primary">
          <i class="fas fa-check-circle mr-3" />
          Save to Database
        </button>
      </div>
    {/if}
  </form>
</Layout>
